


document.addEventListener('DOMContentLoaded', function () {

  // Add a special CSS class when the cart-icon is clicked 
  document.querySelector("#cart-icon").addEventListener("click", function(){
    document.body.classList.toggle("js-show-ajax-cart"); 


  });
});

// Close cart when clicking on the overlay
function closeCart() {
  document.body.classList.toggle("js-show-ajax-cart");
}


    // Listen for the "liquid-ajax-cart:request-end" event which is fired
    
    // after a Shopify Cart API Ajax request is performed
    document.addEventListener('liquid-ajax-cart:request-end', event => {
        const {requestState} = event.detail;
    
        // If the "add to cart" request is successful
        if (requestState.requestType === 'add' && requestState.responseData?.ok) {
    
        // Add the CSS class to the "body" tag
        document.body.classList.add('js-show-ajax-cart');
    
        // Check if js-ajax-cart-empty is not present on the HTML tag
        if (!document.documentElement.classList.contains("js-ajax-cart-empty")) {
            setTimeout(function(){
            document.querySelector("#shopify-section-cart-recomendations").classList.add("cart-recom-slidein");
            }, 500);
        } else {
            document.querySelector("#shopify-section-cart-recomendations").classList.remove("cart-recom-slidein");
        }
        }
    });
    
    // Close cart when clicking on the overlay
    function closeCart() {
        document.body.classList.toggle("js-show-ajax-cart");
    }


    // terms and conditions with popup

    let modal = document.getElementById("terms-modal");
    let acceptButton = document.getElementById("accept-terms");
    
    document.body.addEventListener('click', function(event) {
        let target = event.target;
        let nameAttr = target.getAttribute('name');
        
        if (nameAttr === 'checkout' || nameAttr === 'goto_pp' || nameAttr === 'goto_gc') {
        let agreeCheckbox = document.getElementById('agree');
        
        if (agreeCheckbox.checked) {
            target.form.submit();
        } else {
            modal.style.display = "block";
            event.preventDefault();
        }
        }
    });
    
    acceptButton.onclick = function() {
        modal.style.display = "none";
        var agreeCheckbox = document.getElementById('agree');
        agreeCheckbox.checked = true;
    
        // Redirect to the checkout page
        window.location.href = '/checkout'; 
    }
    
    window.onclick = function(event) {
        if (event.target == modal) {
        modal.style.display = "none";
        }
    }


    // cart instructions dropdown
    function toggleCartInstructions() {
        var dropdown = document.getElementById('cartInstructionDropdown');
        if (dropdown.classList.contains('hidden')) {
            dropdown.classList.remove('hidden');
        } else {
            dropdown.classList.add('hidden');
        }
    }



document.addEventListener('DOMContentLoaded', function() {
  let modal = document.getElementById("terms-modal");
  let acceptButton = document.getElementById("accept-terms");

  document.body.addEventListener('click', function(event) {
    let target = event.target;
    let nameAttr = target.getAttribute('name');
    
    if (nameAttr === 'checkout' || nameAttr === 'goto_pp' || nameAttr === 'goto_gc') {
      let agreeCheckbox = document.getElementById('agree');
    
      if (agreeCheckbox.checked) {
        target.form.submit();
      } else {
        modal.style.display = "block";
        event.preventDefault();
      }
    }
  });

  acceptButton.onclick = function() {
    modal.style.display = "none";
    var agreeCheckbox = document.getElementById('agree');
    agreeCheckbox.checked = true;

    // Redirect to the checkout page
    window.location.href = '/checkout';
  }

  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  }
});

// cart instructions dropdown
function toggleCartInstructions() {
  var dropdown = document.getElementById('cartInstructionDropdown');
  var arrow = document.getElementById('arrow');
  if (dropdown.classList.contains('hidden')) {
      dropdown.classList.remove('hidden');
      arrow.classList.remove('arrow-down');
      arrow.classList.add('arrow-up');
  } else {
      dropdown.classList.add('hidden');
      arrow.classList.remove('arrow-up');
      arrow.classList.add('arrow-down');
  }
}
